(function () {
  var deliveryOptions;
  var optionSelected;
  var deliveryType;

  //console.log('reset called !!');
  
  window.addEventListener('keydown',function(e){if(e.keyIdentifier=='U+000A'||e.keyIdentifier=='Enter'||e.keyCode==13){if(e.target.nodeName=='INPUT'&&e.target.type=='text'){e.preventDefault();return false;}}},true);
	
  reset();

  const dealerInfo = window.localStorage.getItem('dealShipping');
  const distroInfo = window.localStorage.getItem('distroShipping');
 // window.localStorage.setItem("discount", "IAQProduct1");
  if(document.getElementById('customerFirstName') != null){
  	window.localStorage.setItem('customerFirstName', document.getElementById('customerFirstName').getAttribute("data-val"));
  	window.localStorage.setItem('customerLastName', document.getElementById('customerLastName').getAttribute("data-val"));
  }
  console.log('dealerInfo on load - ' +dealerInfo);
  console.log('distroInfo on load ' + distroInfo);
  //Bind onChange events to select el 
  //document.querySelector('input[name=dealerCheckBox]').addEventListener('change', setDealerOption);
  var checkbox = document.querySelector("input[name=dealerCheckBox]");
  if(checkbox != null){  
  	checkbox.addEventListener( 'change', function() {
      if(this.checked) {
        console.log('delivery');
        setDealerOption();
      } else {
        console.log('pickup');
      //  unsetDealerOption();
      }
    });
  }
  if(document.querySelector('select#distributors') != null){
  	document.querySelector('select#distributors').addEventListener('change', setDistributorOption);
  }
  // Set the option bound to the onchange of the select element
  // will set internal var that will be set in local storage later
  function setDistributorOption(e) {
    var element = e.currentTarget;
    console.log("ELEMENT", element)
    var deliverytypedistributor = 'Pickup'; 
    optionSelected = element.id;
    deliveryOptions = element.value;
     if (deliveryOptions != '')
    {
    var obj = JSON.parse(deliveryOptions);
    if(Array.isArray(obj)){
      obj = obj[0];  
    }
    var distributorHVACid = obj.id+'\n'
    }
    //document.getElementById('checkoutBtn').disabled = false;
    window.localStorage.setItem('distroShipping', deliveryOptions);
    window.localStorage.setItem('dealShipping', '');
    if(window.localStorage.getItem('distroShipping') === ''){
      document.getElementById('distributorAddress').value = '';
      document.getElementById('checkoutBtn').disabled = true;
    }
    else {
    setTextArea('distributorAddress');
    document.getElementById('deliverytype').value = deliverytypedistributor;
    document.getElementById('DistributorHVACid').value = distributorHVACid;
    document.getElementById('DealerHVACid').value = null;
    document.getElementById('DealerHVACid').style.display = "none";
    }
  }
  
   if(document.querySelector('select#dealers') != null){
  	document.querySelector('select#dealers').addEventListener('change', setDealerOption);
  }

  function setDealerOption(e){
    var deliverytypedealer = 'Delivery'; 
    deliveryOptions = document.getElementById('dealerLocation').getAttribute("data-val");
    if (deliveryOptions != '')
    {
    var obj = JSON.parse(deliveryOptions);
    if(Array.isArray(obj)){
      obj = obj[0];  
     }
    }
    //var dealerHVACid = obj.id+'\n'
    //console.log('deliveryOptions' + deliveryOptions)
    window.localStorage.setItem('dealShipping', deliveryOptions);
    window.localStorage.setItem('distroShipping', '');
    if(window.localStorage.getItem('dealShipping') === ''){
      document.getElementById('dealerAddress').value = '';
      document.getElementById('dealeraddressalert').innerText = '';
      document.getElementById('checkoutBtn').disabled = true;
    }
    else{
    //setTextArea('dealerAddress');
    document.getElementById('deliverytype').value = deliverytypedealer;
    //document.getElementById('DealerHVACid').value = dealerHVACid;
    document.getElementById('DistributorHVACid').value = null;
    document.getElementById('DistributorHVACid').style.display = "none";
  }
}

  function unsetDealerOption(){
    deliveryOptions = '';
    window.localStorage.removeItem('dealShipping');
    document.getElementById("dealerAddress").value = "";
  }

  function setTextArea(textAreaId) {
    var parsedAddress = parseAddressJSON(deliveryOptions);
    document.getElementById(textAreaId).value = parsedAddress;
    document.getElementById('checkoutBtn').disabled = true;
  }

  function parseAddressJSON(deliveryOptions) {
    //console.log('during parse '+deliveryOptions);
    var obj = JSON.parse(deliveryOptions);
    if(Array.isArray(obj)){
      obj = obj[0];  
    }
    var parsedAddress = obj.name+'\n'
    //if(obj.address.apt_suite != null && obj.address.apt_suite != ''){
      //parsedAddress += ',';
    //}
    parsedAddress += obj.address.address+'\n'+obj.address.city+', '+obj.address.state+', '+obj.address.country+'\n'+'Zip: '+obj.address.zip;
    
    if(obj.address.phone != null && obj.address.phone != ''){
      parsedAddress += '\n'+'Phone: '+obj.address.phone;
    }

    return parsedAddress;

  }

  if(document.getElementById("checkoutBtn") != null){
    document.getElementById("checkoutBtn").addEventListener("click", function() {
      //window.localStorage.setItem('distroShipping', deliveryOptions);
      //window.localStorage.setItem('dealShipping', deliveryOptions);
      window.location = "/cart?step=contact_information";
    });
  }

  function reset(){
    window.localStorage.removeItem('dealShipping');
    window.localStorage.removeItem('distroShipping');
    localStorage.clear();
  }

}());

//window.onload = function() {
  //document.getElementById('dealerShelf').style.display = 'none';
  //document.getElementById('distributorShelf').style.display = 'none';
  
//}

function renderPicklist(radioId) {
  console.log(radioId);
  if(radioId == 'dealer'){
    document.getElementById('distributorarr').value = '';
    var box = document.getElementById('addressFormSectionBoolean').getAttribute("data-val");    
    window.localStorage.setItem('addressFormSectionBoolean', box);
    if (box == 'true')
    {
      document.getElementById('poBoxDeliveryOrdersForm').style.display = 'block';
      document.getElementById("Address1").value = '';
      document.getElementById("Address2").value = '';
      document.getElementById("City").value = '';
      document.getElementById("Province").value = '';
      document.getElementById("Postal_Code").value = '';
      document.getElementById('dealerAddress').value = '';
      document.getElementById('dealeraddressalert').innerText = '';
      document.getElementById('dealerdistributorAddress').value = '';
      document.getElementById('dealerdistributoraddressalert').innerText = '';
      document.getElementById('dealers').value = '';
      document.getElementById('dealerdistributors').value = '';
      document.getElementById('saveBtn').disabled = true; 
      document.getElementById('checkoutBtn').disabled = true;
    }
    else{
      document.getElementById('dealerAddress').value = '';
      document.getElementById('dealeraddressalert').innerText = '';
      document.getElementById('dealerdistributorAddress').value = '';
      document.getElementById('dealerdistributoraddressalert').innerText = '';
      document.getElementById('dealers').value = '';
      document.getElementById('dealerdistributors').value = '';
    }
    document.getElementById('dealpassalert').innerHTML = '';
    document.getElementById('dealdispassalert').innerHTML = '';
    document.getElementById('dispassalert').innerHTML = '';
    document.getElementById('dealpassalertavailable').innerHTML = '';
    document.getElementById('dealdispassalertavailable').innerHTML = '';
    document.getElementById('dispassalertavailable').innerHTML = '';
    //document.getElementById('dealvalretrievalerr').innerHTML = '';
    document.getElementById('dealers').style.display = 'none'; 
    document.getElementById('loader_guest_deal_dropdown').style.display = 'block';
    document.getElementById('dealbutton').disabled = true;
    document.getElementById('dealerShelf').style.display = 'block';
    document.getElementById('dealerdistributorShelf').style.display = 'none';
    document.getElementById('distributorShelf').style.display = 'none';
    var deliveryOptions = document.getElementById('dealerLocation').getAttribute("data-val");
    //console.log('DealerLocation' +deliveryOptions);
    var obj = JSON.parse(deliveryOptions);
    if(Array.isArray(obj)){
      obj = obj[0];
    }
    var parsedZip = obj.address.zip;
    //console.log('DealerZip:' +parsedZip);
    var pickup_only = false;
    var cusId = document.getElementById('customer_id').getAttribute("data-val");
    var shop = document.getElementById('shop_domain').getAttribute("data-val");
    var cusTags = document.getElementById('customerTags').getAttribute("data-val");
    //console.log(cusTags);    
    var parsedTags = JSON.parse(cusTags);
    //console.log(parsedTags);
    //console.log(parsedTags.length);
    var tagsLength = parsedTags.length;
    var containsHVAC = false;
    var HVAC = '';
    var id = '';
    for (var i = 0; i < tagsLength; i++)
      {
        var tag = parsedTags[i];
        var n = tag.includes('HVACID-Distributor');
        //console.log(tag);
        //console.log(n);
        if (tag.includes('HVACID-Distributor'))
        {
           containsHVAC = true;
           HVAC = tag;
           id = HVAC.slice(19);
        }              
      } 
    //console.log('Boolean' +containsHVAC);
    //console.log('ID' +HVAC);
    //console.log(id);
    var delivery = {};
      delivery['zip'] = parsedZip;
      delivery['hvacid'] = id;
      delivery['pickup_only'] = pickup_only;
      delivery['customer_id'] = cusId;
      delivery['shop'] = shop;
    var request = JSON.stringify(delivery); 
    console.log(request);   
    var deliveryOrderLocation = document.getElementById('deliveryLocation').getAttribute("data-val");
    var storeAuthId = document.getElementById('clientID').getAttribute("data-val");
    var storeAuthKey = document.getElementById('clientSecret').getAttribute("data-val");  
    var authorizationBasic = window.btoa(storeAuthId + ':' + storeAuthKey);
     
    //Sending Request to Azure Webapp
    let xhr = new XMLHttpRequest(); 
    let url = deliveryOrderLocation; 
    // open a connection 
    xhr.open("POST", url, true); 

    // Set the request header i.e. which type of content you are sending 
    xhr.setRequestHeader("Content-Type", "application/json"); 
    xhr.setRequestHeader('Authorization', 'Basic ' + authorizationBasic);
	xhr.setRequestHeader('Accept', 'application/json');
      
    xhr.onreadystatechange = function () 
      {  
           var state = xhr.readyState;
           console.log('readystate' +state);
           var status = xhr.status;
           console.log('status' +status);
           var retrievalErr = "*Error in retrieving dealer location";
           var response = xhr.responseText;
           if (state != 4 || status != 200 || response.length <= 2)
              {            
           //console.log('executed');
           //document.getElementById('dealer_span').style.display = 'block'; 
           document.getElementById('dealers').style.display = 'none';
           document.getElementById('loader_guest_deal_dropdown').style.display = 'none';
           //document.getElementById('dealvalretrievalerr').innerHTML = retrievalErr;
           document.getElementById('dealerShelf').style.display = 'none';
           document.getElementById('dealerdistributorShelf').style.display = 'block';  
           document.getElementById('dealdisbutton').disabled = true;
              }       
          else if (xhr.readyState === 4 && xhr.status === 200) 
          {   
           //console.log('Success Loop');
           document.getElementById('dealers').style.display = 'block';
           //document.getElementById('dealvalretrievalerr').innerHTML = '';
           document.getElementById('loader_guest_deal_dropdown').style.display = 'none'; 
           document.getElementById('dealerShelf').style.display = 'block';
           document.getElementById('dealerdistributorShelf').style.display = 'none';
           var response = xhr.responseText;
           console.log('Response' +response);           
           var parsedResponse = JSON.parse(response);
           //console.log('Parsedresponse' +parsedResponse);           
           var length = parsedResponse.length;
           //console.log('length' +length);
           var list = document.getElementById('dealers'); 
           var location = document.getElementById('dealers').value; 
           var lengthdrop = document.getElementById('dealers').options.length;
           //console.log('Drop-down value' +location); 
           //console.log('length' +lengthdrop);
         if (location == '' && lengthdrop == '1')
         {
         for (var j = 0; j < length; j++)
         {
            var option = document.createElement("option"); 
            if(Array.isArray(parsedResponse))
            {
            obj = parsedResponse[j];             
            }           
            var name = obj.name;           
            option.text = name;
            list.add(option); 
            //var Address = obj.name+'\n'; 
            //Address += obj.address.address+'\n'+obj.address.city+', '+obj.address.state+', '+obj.address.country+'\n'+'Zip: '+obj.address.zip;
            //console.log('Dealer Location' +Address);                      
         }  
       
       }
          list.addEventListener('change', function() 
          {
             var deallocation = document.getElementById('dealers').value;
             deliveryOptions = document.getElementById('dealerLocation').getAttribute("data-val");
             //console.log('Selected Dealer Location' +deallocation); 
             for (var k = 0; k < length; k++)
             { 
              if (deallocation == parsedResponse[k].name)
              {               
              //var test = parsedResponse[k].name;
              //console.log('text' +test);
              //console.log('parsedResponse' +JSON.stringify(parsedResponse[k]));
              //window.localStorage.setItem('dealShipping', JSON.stringify(parsedResponse[k]));                
              var obj = JSON.parse(deliveryOptions);
                if(Array.isArray(obj)){
                  obj = obj[0];  
                }
              //var Address = parsedResponse[k].name+'\n'; 
              //Address += parsedResponse[k].address.address+'\n'+parsedResponse[k].address.city+', '+parsedResponse[k].address.state+', '+parsedResponse[k].address.country+'\n'+'Zip: '+parsedResponse[k].address.zip;
              //console.log('Dealer Location\t:' +Address);               
              //document.getElementById('dealerAddress').value = Address;  
              //var dealerHVACid = parsedResponse[k].hvacid;
              var distHVACid = parsedResponse[k].hvacid;
              //console.log('DistributorHVACid' +distHVACid);
              var dealerHVACid = obj.id;
              //console.log('DealerHVACid' +dealerHVACid);
              var Address = obj.name+'\n';
              Address += obj.address.address+'\n'+obj.address.city+', '+obj.address.state+', '+obj.address.country+'\n'+'Zip: '+obj.address.zip;
              if(obj.address.phone != null && obj.address.phone != ''){
               Address += '\n'+'Phone: '+obj.address.phone;
                }
                if (box == 'false')
                {   
                  document.getElementById('dealerAddress').value = Address;
                  document.getElementById('dealeraddressalert').innerText = "Please verify the Shipping Address in Checkout. If it appears incorrectly, please update it before placing your order.";
                }
                else
                {
                  document.getElementById("Address1").value = '';
                  document.getElementById("Address2").value = '';
                  document.getElementById("City").value = '';
                  document.getElementById("Province").value = '';
                  document.getElementById("Postal_Code").value = '';
                  document.getElementById('dealerAddress').value = '';
                  document.getElementById('dealeraddressalert').innerText = '';  
                  document.getElementById('saveBtn').disabled = true;
                }
              document.getElementById('dealbutton').disabled = false;  
              document.getElementById('DealerHVACid').value = dealerHVACid;
              document.getElementById('DistributorHVACid').value = distHVACid;
              document.getElementById('checkoutBtn').disabled = true;
              document.getElementById('dealpassalert').innerHTML = '';
              document.getElementById('dispassalert').innerHTML = '';
              document.getElementById('dealpassalertavailable').innerHTML = '';
              document.getElementById('dispassalertavailable').innerHTML = '';
              }
              else if (deallocation == '')
              {
                if (box == 'true')
                {
                  document.getElementById("Address1").value = '';
                  document.getElementById("Address2").value = '';
                  document.getElementById("City").value = '';
                  document.getElementById("Province").value = '';
                  document.getElementById("Postal_Code").value = '';
                  document.getElementById('saveBtn').disabled = true;
                }
              document.getElementById('dealerAddress').value = '';
              document.getElementById('dealeraddressalert').innerText = '';
              document.getElementById('dealbutton').disabled = true;
              document.getElementById('checkoutBtn').disabled = true;
              document.getElementById('dealpassalert').innerHTML = '';
              document.getElementById('dispassalert').innerHTML = '';
              document.getElementById('dealpassalertavailable').innerHTML = '';
              document.getElementById('dispassalertavailable').innerHTML = '';
              }              
               
             }
           
          });
        
      }
            
    }; 
      
      // Sending data with the request 
      xhr.send(request); 
    
    if(document.getElementById('dealerCheckBox').checked == false){
      document.getElementById('dealerCheckBox').click();
    }
  }
  if(radioId == 'distributor'){
    document.getElementById('distributorarr').value = '';
    document.getElementById('deliverytype').value = 'Pickup';
    var box = document.getElementById('addressFormSectionBoolean').getAttribute("data-val");
    window.localStorage.setItem('addressFormSectionBoolean', box);
    if (box == 'true')
    {   
      document.getElementById('poBoxDeliveryOrdersForm').style.display = 'none';
      document.getElementById('dealerAddress').value = '';
      document.getElementById('dealeraddressalert').innerText = '';
      document.getElementById('dealerdistributorAddress').value = '';
      document.getElementById('dealerdistributoraddressalert').innerText = '';
      document.getElementById('dealers').value = ''
      document.getElementById('dealerdistributors').value = ''
    }
    else{
      document.getElementById('dealerAddress').value = '';
      document.getElementById('dealeraddressalert').innerText = '';
      document.getElementById('dealerdistributorAddress').value = '';
      document.getElementById('dealerdistributoraddressalert').innerText = '';
      document.getElementById('dealers').value = '';
      document.getElementById('dealerdistributors').value = '';
    }
    document.getElementById('distributors').value = '';
    document.getElementById('distributorAddress').value = '';
    
    document.getElementById('dealpassalert').innerHTML = '';
    document.getElementById('dealdispassalert').innerHTML = '';
    document.getElementById('dispassalert').innerHTML = '';
    document.getElementById('dealpassalertavailable').innerHTML = '';
    document.getElementById('dealdispassalertavailable').innerHTML = '';
    document.getElementById('dispassalertavailable').innerHTML = '';
    if(document.getElementById('dealerCheckBox').checked == true){
      document.getElementById('dealerCheckBox').click();
    }
    document.getElementById('dealerShelf').style.display = 'none';
    document.getElementById('dealerdistributorShelf').style.display = 'none';
    document.getElementById('distributorShelf').style.display = 'block';
    if(document.getElementById("distributorAddress").value === ""){
      document.getElementById('checkoutBtn').disabled = true;
      document.getElementById('distButton').disabled = true;
    }
  }
}


// To display a popup 
window.addEventListener('load', (event) => {
  var dealerRadio = document.getElementById('dealer');
  if(dealerRadio == null && document.getElementById('distributor') != null){
    document.getElementById('distributor').click();
  }
  //alert("Please confirm inventory with your distributor before placing the order!");
});

//window.onload = function() {
  
//var cart =  document.getElementById('CartProducts').value
  
  //if( cart == product.title)
  //{
  //document.getElementById('AddToCart').disabled = true;
  //}
  
//}

//Script to disable the get inventory button 

function getdealvalues(e) {
var selDeal = document.getElementById('dealers').value;
  if (selDeal == '')
  {
    document.getElementById('dealbutton').disabled = true;
    document.getElementById('dealerAddress').value = '';
    document.getElementById('dealeraddressalert').innerText = '';
    document.getElementById("checkoutBtn").disabled = true;
    document.getElementById('dealpassalert').innerHTML = '';
    document.getElementById('dealpassalertavailable').innerHTML = '';
  }
  else 
  {
   document.getElementById('dealbutton').disabled = false;
   document.getElementById('dealpassalert').innerHTML = '';
   document.getElementById('dealpassalertavailable').innerHTML = '';
   document.getElementById("checkoutBtn").disabled = true;
  }
}

function getdistvalues() {
var selDis = document.getElementById('distributors').value;
  if (selDis == '')
  {
    document.getElementById('distButton').disabled = true;
    document.getElementById('distributorAddress').value = '';
    document.getElementById("checkoutBtn").disabled = true;
    document.getElementById('dispassalert').innerHTML = '';
    document.getElementById('dispassalertavailable').innerHTML = '';
  }
  else 
  {
    // one line added 
    document.getElementById('distributorarr').value = selDis;
    checkBrandAvailability();
   document.getElementById('distButton').disabled = false;
   document.getElementById('dispassalert').innerHTML = '';
   document.getElementById('dispassalertavailable').innerHTML = '';
  }
}

function getdealdistvalues(){

 document.getElementById('dealdisbutton').disabled = false;
 document.getElementById("checkoutBtn").disabled = true;
 var deliverytypedealeristributor = 'Delivery'; 
 var dealdislocation = document.getElementById('dealerdistributors').value;
 //console.log(dealdislocation);
 var box = document.getElementById('addressFormSectionBoolean').getAttribute("data-val");
  if (dealdislocation != '')
    {
 var dealdisobj = JSON.parse(dealdislocation);
    if(Array.isArray(obj)){
      dealdisobj = dealdisobj[0];
    }
 var distributorHVACid = dealdisobj.id; 
    }
 //console.log('distributorHVACid' +distributorHVACid);
 var deliveryOptions = document.getElementById('dealerLocation').getAttribute("data-val");
 var obj = JSON.parse(deliveryOptions);
  if(Array.isArray(obj)){
    obj = obj[0];  
  }
  var dealerHVACid = obj.id;
  //console.log('dealerHVACid' +dealerHVACid);
  var Address = obj.name+'\n';
  Address += obj.address.address+'\n'+obj.address.city+', '+obj.address.state+', '+obj.address.country+'\n'+'Zip: '+obj.address.zip;
  if(obj.address.phone != null && obj.address.phone != ''){
    Address += '\n'+'Phone: '+obj.address.phone;
  }
if (dealdislocation == '')
  {
    document.getElementById('dealdisbutton').disabled = true;
    document.getElementById('dealerdistributorAddress').value = '';
    document.getElementById('dealerdistributoraddressalert').innerText = '';
    document.getElementById("checkoutBtn").disabled = true;
    document.getElementById('dealdispassalert').innerHTML = '';
    document.getElementById('dealdispassalertavailable').innerHTML = '';
    if (box == 'true')
    { 
      document.getElementById('saveBtn').disabled = true;
      document.getElementById("Address1").value = ''
      document.getElementById("Address2").value = ''
      document.getElementById("City").value = ''
      document.getElementById("Province").value = ''
      document.getElementById("Postal_Code").value = ''
    }
  }
  else 
  {
   document.getElementById('dealerdistributorAddress').value = Address;
   document.getElementById('dealerdistributoraddressalert').innerText = "Please verify the Shipping Address in Checkout. If it appears incorrectly, please update it before placing your order.";
   window.localStorage.setItem('dealShipping', deliveryOptions);
   document.getElementById('dealdisbutton').disabled = false;
   document.getElementById('dealdispassalert').innerHTML = '';
   document.getElementById('dealdispassalertavailable').innerHTML = '';
   document.getElementById('deliverytype').value = deliverytypedealeristributor;
   document.getElementById('DealerHVACid').value = dealerHVACid;
   document.getElementById('DistributorHVACid').value = distributorHVACid;
    if (box == 'true')
    { 
      document.getElementById('saveBtn').disabled = true;
      document.getElementById("Address1").value = ''
      document.getElementById("Address2").value = ''
      document.getElementById("City").value = ''
      document.getElementById("Province").value = ''
      document.getElementById("Postal_Code").value = ''
    }
  }
       
}

//Script to check the dealer and distributor inventory
var itemsList = [];
function distributorInventory() {  
  
  //to filter and remove the duplicate values from an array
  const resultArr = itemsList.filter((data,index)=>{
    return itemsList.indexOf(data) === index;
  })
  // resets the cart items inventory value
  if (resultArr.length != 0)
  {
    for (var y = 0; y < resultArr.length; y++)
    {  
      document.getElementById(resultArr[y]).value = '';
    }
  }
  var selectedDealVal = '';
  var selectedDealDisVal = '';
  var selectedDis = '';
    document.getElementById('distButton').style.display = 'none';
    document.getElementById('dealbutton').style.display = 'none';
    document.getElementById('dealdisbutton').style.display = 'none';
    document.getElementById('loader_guest_deal').style.display = 'block';
    document.getElementById('loader_guest_disdeal').style.display = 'block';
    document.getElementById('loader_guest_dis').style.display = 'block';
    var box = document.getElementById('addressFormSectionBoolean').getAttribute("data-val"); 
    //Dealer
    var selectedDeal = document.getElementById('dealerLocation').getAttribute("data-val");
    //var selectedDeal = window.localStorage.getItem('dealShipping');
    //console.log('Dealer' +selectedDeal);
    var selectedDis = document.getElementById('distributors').value;
    //console.log('Distributor' +selectedDis);   
  if (selectedDis == ''){
    document.getElementById('distButton').style.display = 'none';
    document.getElementById('loader_guest_dis').style.display = 'block';
    setTimeout(function(){ 
      document.getElementById('distButton').style.display = 'block';
      document.getElementById('loader_guest_dis').style.display = 'none';
    }, 5000);
  }
    var dealerRadio = document.getElementById('dealerAddress').value;
    var dealDisRadio = document.getElementById('dealerdistributorAddress').value;
    selectedDealVal = document.getElementById('dealers').value;
    selectedDealDisVal = document.getElementById('dealerdistributors').value;
    //console.log('Dealer' +dealerRadio);
  if (box == 'true')
  {
    document.getElementById('saveBtn').disabled = false;
    if (selectedDealVal != '' || selectedDealDisVal != ''){
      console.log('dealer');
      var obj = JSON.parse(selectedDeal);
      if(Array.isArray(obj)){
        obj = obj[0];
      }
    }
    else if (selectedDis != '') {
      console.log('distributor');
      var obj = JSON.parse(selectedDis);
      if(Array.isArray(obj)){
        obj = obj[0];     
      }
    } 
  }
  else
  {
    if (dealerRadio != '' || dealDisRadio != ''){
      var obj = JSON.parse(selectedDeal);
      if(Array.isArray(obj)){
        obj = obj[0];
      }
    }
    else if (selectedDis != '') {
      var obj = JSON.parse(selectedDis);
      if(Array.isArray(obj)){
        obj = obj[0];     
      }
    }  
  }
  var message = 'False';
  if (selectedDis != '' || dealerRadio != '' || dealDisRadio != '' || selectedDealVal != '' || selectedDealDisVal != '') {
  var dealerdistributorHVACid = obj.id;
  //console.log('hvacid\t' +dealerdistributorHVACid);
  var itemsArray = document.getElementById('lineItemsArray').getAttribute("data-val");  
  //console.log('cartitems\t' +itemsArray);  
  var items = JSON.parse(itemsArray);
  //console.log(items.length);
  var cartItemQty = document.getElementById('cartitemswithqty').getAttribute("data-val");
  var cartQuantity = JSON.parse(cartItemQty);
  //console.log(cartQuantity.length);
  var getInventory = {};
      getInventory['hvacid'] = dealerdistributorHVACid;
      getInventory['items'] = items;
  var inventory = JSON.stringify(getInventory);  
  var inv = inventory.replace(/\\/g, '');
  //console.log('Request' +inv); 
  
  var bolTrue = '\u2705';
  var bolFalse = '\u274C';  
  
  // Distributor webapp endpoint URL added in metafields
  var distinventoryURL = document.getElementById('distinventoryURL').getAttribute("data-val");
  var storeAuthId = document.getElementById('clientID').getAttribute("data-val");
  var storeAuthKey = document.getElementById('clientSecret').getAttribute("data-val");  
  var authorizationBasic = window.btoa(storeAuthId + ':' + storeAuthKey);
  
  //Sending Request to Azure Webapp
      let xhr = new XMLHttpRequest(); 
      let url = distinventoryURL; 
      // open a connection 
      xhr.open("POST", url, true); 

      // Set the request header i.e. which type of content you are sending 
      xhr.setRequestHeader("Content-Type", "application/json"); 
      xhr.setRequestHeader('Authorization', 'Basic ' + authorizationBasic);
	  xhr.setRequestHeader('Accept', 'application/json');

      // Create a state change callback  function for endpoint response 
      xhr.onreadystatechange = function () 
      {  
           var state = xhr.readyState;
           console.log('readystate' +state);
           var status = xhr.status;
           console.log('status' +status);
        if (state != 4)
              { 
           console.log('Not equal to 4');               
           document.getElementById('distButton').style.display = 'block';
           document.getElementById('dealdisbutton').style.display = 'block';
           document.getElementById('dealbutton').style.display = 'block';
           document.getElementById('loader_guest_deal').style.display = 'none';
           document.getElementById('loader_guest_disdeal').style.display = 'none';
           document.getElementById('loader_guest_dis').style.display = 'none';
                //Enable Checkout button  only after getting Inventory details  
                if(document.getElementById('distributor').checked)
                {
                  document.getElementById("checkoutBtn").disabled = false;
                }
                if(document.getElementById('dealer').checked)
                {
                  if (box == 'true')
                  {
                    if (document.getElementById('dealerAddress').value)
                    {
                      document.getElementById("checkoutBtn").disabled = false;
                    }
                    else 
                    {
                      document.getElementById("checkoutBtn").disabled = true;
                    }
                  }
                  else{
                    document.getElementById("checkoutBtn").disabled = false;
                  }
                }
              }           
        else if (xhr.readyState === 4 && xhr.status === 200) {
          var response = xhr.responseText;
          console.log(response);
          var disInv = JSON.parse(response);
          //console.log(disInv);        
          var disInvItems = disInv.items;
          //console.log(disInvItems)
          var responseLength = disInvItems.length;
          //console.log(responseLength);
           // To loop list of responses and assigning to local variables
           for(var i = 0; i < responseLength; i++){
           if(Array.isArray(disInvItems)){                  
           var sku = disInvItems[i].sku; 
           var qty = disInvItems[i].quantity;
           console.log(sku, qty)                 
             }             
     
           // To loop cart items and compare with response sku id
           for (var j = 0; j < items.length; j++)
             {
               if (sku == items[j])
                 {   
                   //Iterating over cart items quantity and comparing with response inventory qty 
                     for (var k = 0; k < items.length; k++)
                     {
                       if (qty >= cartQuantity[k] )
                       {
                          document.getElementById(items[j]).value = bolTrue;
                          //console.log('inventory' +document.getElementById(items[j]).value);
                          //console.log('Quantity is available');
                         localStorage.setItem("itemsSign", itemsList.push(items[j]));
                          var note ="*Items(s) are in stock ready for pick-up in 2-3 business days"
                          document.getElementById('dealpassalert').innerHTML = '';
                          document.getElementById('dealdispassalert').innerHTML = '';
                          document.getElementById('dispassalert').innerHTML = '';
                          document.getElementById('dealpassalertavailable').innerHTML = note;
                          document.getElementById('dealdispassalertavailable').innerHTML = note;
                          document.getElementById('dispassalertavailable').innerHTML = note;
                       }
                       else 
                       {
                          document.getElementById(items[j]).value = bolFalse;
                          //console.log('inventory' +document.getElementById(items[j]).value);
                         localStorage.setItem("itemsSign", itemsList.push(items[j]));
                          var message = 'True'
                          if (message)
                          {
                            //console.log('Quantity is not available');
                            var note = "*Please confirm inventory with your distributor before placing the order!"
                            document.getElementById('dealpassalert').innerHTML = note;
                            document.getElementById('dealdispassalert').innerHTML = note;
                            document.getElementById('dispassalert').innerHTML = note;
                            document.getElementById('dealpassalertavailable').innerHTML = '';
                            document.getElementById('dealdispassalertavailable').innerHTML = '';
                            document.getElementById('dispassalertavailable').innerHTML = '';
                            /*setTimeout(function(){ 
                            document.getElementById('passalert').innerHTML = '';
                            }, 5000);*/
                          }
                       }
                     }
                   }
                 }
               }
          //Enable Checkout button  only after getting Inventory details  
          if(document.getElementById('distributor').checked)
          {
            document.getElementById("checkoutBtn").disabled = false;
          }
          if(document.getElementById('dealer').checked)
          {
            if (box == 'true')
            {
              if (document.getElementById('dealerAddress').value)
              {
                document.getElementById("checkoutBtn").disabled = false;
              }
              else 
              {
                document.getElementById("checkoutBtn").disabled = true;
              }
            }
            else{
              document.getElementById("checkoutBtn").disabled = false;
            }
          }
        }
          
         if (xhr.readyState != 4 && xhr.status != 200)
           {
             //alert("Please confirm inventory with your distributor before placing the order!");  
              for (var j = 0; j < items.length; j++)
             {
                document.getElementById(items[j]).value = bolFalse;
             }
             var message = 'True'
             if (message)
             {
               //console.log('Callout not equal to 4 and 200');
               var note = "*Please confirm inventory with your distributor before placing the order!"
               document.getElementById('dealpassalert').innerHTML = note;
               document.getElementById('dealdispassalert').innerHTML = note;
               document.getElementById('dispassalert').innerHTML = note;
               document.getElementById('dealpassalertavailable').innerHTML = '';
               document.getElementById('dealdispassalertavailable').innerHTML = '';
               document.getElementById('dispassalertavailable').innerHTML = '';
               /*setTimeout(function(){ 
               document.getElementById('passalert').innerHTML = '';
               }, 5000);*/
             }
             //Enable Checkout button  only after getting Inventory details  
             if(document.getElementById('distributor').checked)
             {
               document.getElementById("checkoutBtn").disabled = false;
             }
             if(document.getElementById('dealer').checked)
             {
               if (box == 'true')
               {
                 if (document.getElementById('dealerAddress').value)
                 {
                   document.getElementById("checkoutBtn").disabled = false;
                 }
                 else 
                 {
                   document.getElementById("checkoutBtn").disabled = true;
                 }
               }
               else{
                 document.getElementById("checkoutBtn").disabled = false;
               }
             }
           }         
      }; 
      
      // Sending data with the request 
      xhr.send(inv); 
   }
  
    //Enable Checkout button only after getting Inventory details 
    //document.getElementById("checkoutBtn").disabled = false;
}

// search distributor option 

function filterFunction() {
  var cusinput, filter, a, i, disList;
  cusinput = document.getElementById("myInput");
  filter = cusinput.value.toUpperCase();
  disList = document.getElementById("distributors");
  var dropdown = document.getElementById("distributors").options;
  a = disList.getElementsByTagName("option");
   for (i = 0; i < a.length; i++) {
    txtValue = a[i].textContent || a[i].innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1 && filter != '') {
      a[i].style.display = "";
      dropdown[i].selected = true;
       e = new Event('change');
      disList.dispatchEvent(e);
      break;                     //Added to prevent redundant brand availability API calls      
    } else {
      //a[i].style.display = "none";
      clrErr();
    }
  }
}

// to clear the search results on deleting / clearing the search input

function clrErr() {
var input = document.getElementById("myInput").value;
if (input == '')
{
    document.getElementById("distributors").selectedIndex = "-1";
    document.getElementById('distributorAddress').value = '';
    document.getElementById('distButton').disabled = true;
}
  
}
  
// function to display error message when the distributor_location or dealer_location doesn't exist or equal to null

window.addEventListener('load', function()
     {
  var metafieldExist = document.getElementById('messageDisplayMetafield').getAttribute("data-val");
  //console.log('metafieldExist' +metafieldExist);
  var metafieldErrorDispCheck = document.getElementById('metafieldErrordisp').getAttribute("data-val");
  var message = "*An error occurred, please contact PUP Support."
  var cusTags = document.getElementById('customerTags').getAttribute("data-val");   
  var parsedTags = JSON.parse(cusTags);
  var tagsLength = parsedTags.length;
  var containsDis = false;
  for (var i = 0; i < tagsLength; i++)
  {
    var tag = parsedTags[i];
    if (tag.startsWith('Distributor'))
    {
      containsDis = true;      
    } 
  }
  
  if (metafieldErrorDispCheck == 'true')
  {
    if (!containsDis)
    {
      if (metafieldExist == 'true')
      {
        document.getElementById('metafieldError').innerHTML = message;
        document.getElementById("dealer").disabled = true;
        document.getElementById("distributor").disabled = true;
      }
      else 
      {
        document.getElementById('metafieldError').innerHTML = '';
        document.getElementById("dealer").disabled = false;
        document.getElementById("distributor").disabled = false;

      }

    }
    else{

      if (metafieldExist == 'true')
      {
        document.getElementById('metafieldError').innerHTML = message;
        document.getElementById("distributor").disabled = true;
        document.getElementById("distributors").disabled = true;
        document.getElementById("myInput").disabled = true;
      }
      else 
      {
        document.getElementById('metafieldError').innerHTML = '';
        document.getElementById("distributor").disabled = false;
        document.getElementById("distributors").disabled = false;
        document.getElementById("myInput").disabled = false;

      }

    }
  }

});

// function to validate the PO Box form fields 
// Executes on click of SAVE button
function evaluateFields(){

  var address1validation = document.getElementById("Address1");
  var address2validation = document.getElementById("Address2");
  var cityvalidation = document.getElementById("City");
  var statevalidation = document.getElementById("Province");
  var country = document.getElementById("Country").value;
  var postalcodevalidation = document.getElementById("Postal_Code");  

  if (address1validation.validity.valueMissing)
  {

    var message = "*Address 1 is required.";
    document.getElementById("formError").innerHTML = message;

  } 
  else if (cityvalidation.validity.valueMissing)
  {

    var message = "*City field is required.";
    document.getElementById("formError").innerHTML = message;

  }
  else if (cityvalidation.validity.patternMismatch)
  {

    var message = "*Must contain only characters in City field.";
    document.getElementById("formError").innerHTML = message;

  }
  else if (statevalidation.validity.valueMissing)
  {

    var message = "*State field is required.";
    document.getElementById("formError").innerHTML = message;

  }
  else if (statevalidation.validity.patternMismatch)
  {

    var message = "*Must contain only characters in State field.";
    document.getElementById("formError").innerHTML = message;

  }
  else if (postalcodevalidation.validity.valueMissing)
  {

    var message = "*Postal Code field is required.";
    document.getElementById("formError").innerHTML = message;

  }
  else if (country)
  {
    var execute = ''    
    if (country == 'US')
    {
      if (postalcodevalidation.validity.patternMismatch)
      {
        var message = "*Must contain only numbers in Postal Code field.";
        document.getElementById("formError").innerHTML = message;     
      }
      else
      {
        execute = 'true'
      }
    }
    else
    {
      execute = 'true'
    }

  }
  
  if (execute) 
  {
    var address1 = document.getElementById("Address1").value; 
    var address2 = document.getElementById("Address2").value; 
    var city = document.getElementById("City").value;
    var state = document.getElementById("Province").value;    
    var country = document.getElementById("Country").value;
    console.log(state + country);
    var postalCode = document.getElementById("Postal_Code").value;

    if(notEmpty(address1) && notEmpty(city) && notEmpty(state) && 
       notEmpty(postalCode))
    {       
      var Address = address1+'\n';
      var allResults = [];
      var eachResult = {}
      if (address2)
      {
        console.log('If loop');
        Address += address2+'\n'+city+', '+state+', '+country+'\n'+'Zip: '+postalCode;
        //local storage - checkout
        eachResult['address1'] = address1;
        eachResult['address2'] = address2;
        eachResult['city'] = city; 
        eachResult['state'] = state; 
        eachResult['country'] = country;
        eachResult['postal_code'] = postalCode;        
      }
      else
      {
        console.log('Else loop');
        Address += city+', '+state+', '+country+'\n'+'Zip: '+postalCode;
        // local storage - checkout
        eachResult['address1'] = address1;
        eachResult['address2'] = '';
        eachResult['city'] = city; 
        eachResult['state'] = state;
        eachResult['country'] = country;
        eachResult['postal_code'] = postalCode;
      }
      allResults.push(eachResult); 
      document.getElementById('dealerAddress').value = Address;
      document.getElementById('dealerdistributorAddress').value = Address;
      document.getElementById('checkoutBtn').disabled = false;
      document.getElementById('saveBtn').disabled = true;      
      window.localStorage.setItem('deliveryOrdersPO', JSON.stringify(allResults));
    }
    else
    {
      document.getElementById('checkoutBtn').disabled = true;
    }
  }

}

// function to validate the fields with required property 
function notEmpty(text) 
{
  if (text == null || text.length == 0)
  { 	
    return false; 
  }  	
  return true; 
}

// function to reset the error message
function clearError(){

  var message = ''
  document.getElementById("formError").innerHTML = message;

}

//Checks whether the specific brand is available with the distributor in the store
function checkBrandAvailability() {
  //Selected distributor's HVAC ID
  var hvacid = JSON.parse(document.getElementById('distributors').value)?.id;
  console.log("Brand check Request started for Distributor HVAC ID:", hvacid);
  //Current Store Name
  var store = Shopify["shop"].split(".")[0];
  //Brand of the items in cart
  var brand = document.getElementById('brandData')?.getAttribute("data-val");
  if(brand){
    var cartBrandCheckURL = document.getElementById('cartBrandCheckURL').getAttribute("data-val");
    var storeAuthId = document.getElementById('clientID').getAttribute("data-val");
    var storeAuthKey = document.getElementById('clientSecret').getAttribute("data-val");
    var authorizationBasic = window.btoa(storeAuthId + ':' + storeAuthKey);
    console.log("AUTH", authorizationBasic)
  
    document.getElementById('loader_guest_dis').style.display = 'block'; 
    document.getElementById("brandcheckalert").style.display = "none";
    document.getElementById('distButton').style.display = 'none';
  
  
  
    //Sending Request to Azure Webapp
    let xhrdis = new XMLHttpRequest();
    let urldis = `${cartBrandCheckURL}/${store}/${hvacid}/${brand}`;
    // Open connection
    xhrdis.open("GET", urldis, true);
  
    // Set the request headers
    xhrdis.setRequestHeader("Content-Type", "application/json");
    xhrdis.setRequestHeader("Authorization", "Basic " + authorizationBasic);
    xhrdis.setRequestHeader("Accept", "application/json");
  
    xhrdis.onreadystatechange = function() {
        if (xhrdis.readyState != 4) {
            document.getElementById("loader_guest_dis").style.display = "none";
            document.getElementById('distButton').style.display = 'block';
            document.getElementById('distButton').disabled = false;
        } else if (xhrdis.readyState === 4 && xhrdis.status === 200) {
            document.getElementById('loader_guest_dis').style.display = 'none';
            document.getElementById('distButton').style.display = 'block';
  
            var response = JSON.parse(xhrdis.responseText);
            const currentDistributorValue = document.getElementById('distributors').value;
            if (!currentDistributorValue) {
              return;
            }
            const currentDistributorId = JSON.parse(currentDistributorValue)?.id;
            if (hvacid != currentDistributorId) {
              console.log("Ignoring stale response for Distributor HVACID:", hvacid);
              return;
            }
            if(!response.isBrandValid) {
              document.getElementById("brandcheckalert").innerText = "This distributor does not have the brand you added to the cart. Please change the distributor or update the cart."
              document.getElementById('distButton').disabled = true;
              document.getElementById("brandcheckalert").style.display = "block";
            }else {
              document.getElementById('distButton').disabled = false;
            }
        }
    };
  
    // Sending data with the request
    xhrdis.send();

  }else{
    document.getElementById("brandcheckalert").style.display = "block";
    document.getElementById("brandcheckalert").innerText = "Unknown brands found in the cart which are not available with the distributor"
  }

}
